import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import vowRatings from "../../../../src/data/articles/cube-prospective-innistrad-crimson-vow/vow-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  vowRatings,
  ProspectiveIntro,
  React
};